// Data catalog for the "Reifen" (tires) wizard.

export const TIRE_TYPES = [
  "Autoreifen",
  "SUV-/Geländewagenreifen",
  "Transporterreifen",
  "LKW-Reifen",
  "Motorradreifen",
  "Fahrradreifen",
  "Sonstige Reifen",
];

export const ON_RIMS_OPTIONS = ["Ja", "Teilweise", "Nein", "Nicht bekannt"];

export const TIRE_LOCATIONS = ["Garage", "Keller", "Werkstatt", "Lager", "Außenbereich", "Sonstiges"];
export const FLOOR_REQUIRED_LOCATIONS = ["Keller", "Lager"]; // and "upper floor" if the user specifies one via free text

export const LOADING_HELP_OPTIONS = ["Nur Transport", "Nur Beladung", "Nur Entladung", "Beladung und Entladung"];

// LKW-Reifen (heavy commercial truck tires) or a large quantity always
// triggers manual pricing review — mirrored server-side in
// TransportController::needsManualReview().
export const MANUAL_REVIEW_TYPE = "LKW-Reifen";
export const MANUAL_REVIEW_QUANTITY_THRESHOLD = 20;